import script from "./MallToastHost.vue?vue&type=script&setup=true&lang=ts"
export * from "./MallToastHost.vue?vue&type=script&setup=true&lang=ts"

import "./MallToastHost.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__